/*
 * File: App.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 3:20:12 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Button, Layout, Row, Space, Typography } from 'antd';
import { Loader } from 'components/common/Loader';
import { PageHeader } from 'components/common/PageHeader';
import { PageSubHeader } from 'components/common/PageSubHeader';
import { useAuthentication } from 'hooks/useAuthentication';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'redux/store';
import { MainRoutes } from 'routes/MainRoutes';
import { InlineStylesModel } from './models/InlineStylesModel';

const { Header, Content } = Layout;
const styles: InlineStylesModel = {
  layout: {
    height: '100vh'
  },
  header: {
    padding: 0,
    lineHeight: 1,
    justifyContent: 'center'
  },
  content: {
    padding: '10px 50px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 1920,
    alignSelf: 'center',
    width: '100%'
  },
  somethingWrong: {
    textAlign: 'center',
    height: '100vh'
  }
};

export const App = (): JSX.Element => {
  const location = useLocation();
  const { isAppLoading, cookieNotFound, authError, signIn } = useAuthentication();
  const { accessToken, acuityContext } = useAppSelector((state) => state.app);

  // Sign-in failed again straight after a trip to the login page. Ask, rather than redirect again.
  if (authError) {
    return (
      <Row style={styles.somethingWrong} justify="center" align="middle">
        <Space direction="vertical" align="center">
          <Typography.Title level={4}>{authError}</Typography.Title>
          <Button type="primary" onClick={signIn}>
            Sign in
          </Button>
        </Space>
      </Row>
    );
  }

  if (isAppLoading || !accessToken || (!acuityContext && !cookieNotFound)) {
    return (
      <div style={{ paddingTop: '40vh' }}>
        <Loader />
      </div>
    );
  }

  if (cookieNotFound) {
    return (
      <Row style={styles.somethingWrong} justify="center" align="middle">
        <Typography.Title level={4}>Oops something went wrong... Redirecting you back to dashboard... Please try again in a few moments...</Typography.Title>
      </Row>
    );
  }

  return (
    <Layout style={styles.layout}>
      {/* <BackTop /> */}
      <Header style={styles.header}>
        <PageHeader />
      </Header>
      {location.pathname !== '/about' && location.pathname !== '/profile' ? <PageSubHeader /> : null}
      <Content style={styles.content}>
        <MainRoutes />
      </Content>
    </Layout>
  );
};
